module.exports = __webpack_public_path__ + "media/newstyle/images/instagram-4e1040c60019e895687b9d7c136e2f28.svg";